
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SHARED_COMPONENTS } from '../../../shared/shared-imports';
import { Subscription } from 'rxjs';
import { AccountModel } from '../../../shared/models/loginuser.model';
import { SharedService } from '../../../shared/services/shared.service';
import { Utils } from '../../../Utils/utils';
import { DocumentServiceType, UserType } from '../../../shared/constants/services.enum';
import { DatePipe } from '@angular/common';
import { AttachmentService } from '../../../core/services/attachment.service';
import { finalize } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { RoutesPath } from '../../../shared/constants/routes-path';
type RowKind = 'folder' | 'file';
@Component({
  selector: 'app-documents',
  imports: [ReactiveFormsModule, TranslateModule, ...SHARED_COMPONENTS],
  templateUrl: './documents.component.html',
  styleUrl: './documents.component.scss'
})
export class DocumentsComponent implements OnInit {
  filterForm!: FormGroup;
  sub!: Subscription;
  selectedIds = new Set<string>();
  accountCSN: any = "";
  accountId: any = "";
  selectedMembershipName: string = "";
  memberships: any = [];
  private allDocuments: any[] = [];

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private sharedService: SharedService,
    private attachmentService: AttachmentService
  ) {
    this.filterForm = this.fb.group({
      membership: [null],
      search: ''
    });
    this.accountCSN = this.sharedService.getCsnAccountId('csn'); //1298
    this.accountId = this.sharedService.getCsnAccountId('id'); //7093
    let accounts = Utils.checkIsArray(this.sharedService.getUserProfile()?.Account) ?? [];
    accounts?.map((u: AccountModel) => {
      if (u['DC Name English'] &&
        (u['Account Type Code'] == UserType.MEMBER || u['Account Type Code'] == UserType.MEMBER_AR)
        && u['Primary User'] == "Y"
      ) {
        let obj = {
          Name: u['CSN']
            ? `${u['DC Name English']} (${u['CSN']})`
            : `${u['DC Name English']}`,
          Value: u['CSN'] ? u['CSN'] : u['Id'],
          isCSN: !!u['CSN']
        };
        this.memberships.push(obj);
      }
    });
  }

  // This method is used to handle the on init lifecycle hook
  ngOnInit(): void {
    if (this.memberships && this.memberships.length > 0) {
      this.filterForm.get("membership")?.setValue(this.accountCSN ? this.accountCSN : this.accountId);
      this.selectedMembershipName = this.sharedService.getPrimaryAccount()?.['DC Name English'];
      this.getMemberDocuments();
    } else {
      this.sharedService.toastMessage('INFO', 'NOT_ALLOWED_VIEW_DOCUMENTS', 'info', true);
      this.router.navigate([RoutesPath.DASHBOARD]);
    }
  }

  loader: boolean = false;
  listOfDocuments: any = [];
  totalRecords: number = 0;
  currentPage: number = 1;
  pageSize: number = 10;
  downloadingIds = new Set<string>();
  // This method is used to get member documents
  getMemberDocuments() {
    this.listOfDocuments = [];
    this.selectedIds.clear();
    this.updatePagination(true);
    const memNumber = this.accountCSN || this.accountId || this.filterForm.get("membership")?.value;
    if (!memNumber) {
      return;
    }
    if (!this.accountCSN) {
      return
    }
    this.loader = true;
    let documentType = DocumentServiceType.MEMBERSHIP_WALLET;
    this.sharedService
      .getDocuments('', documentType, false, {
        memNumber: memNumber
      })
      .subscribe({
        next: (response: any) => {
          if (response.success) {
            const folderId = response.data?.folderId ?? null;
            this.allDocuments = Utils.checkIsArray(response.data?.documents).map((doc: any) => ({
              ...doc,
              memberFolderId: doc?.memberFolderId ?? doc?.folderId ?? folderId
            }));
            this.listOfDocuments = [...this.allDocuments];
            this.applySearchFilter();
            this.loader = false;
          } else {
            this.listOfDocuments = [];
            this.updatePagination(true);
            this.loader = false;
          }
        },
        error: () => {
          this.listOfDocuments = [];
          this.updatePagination(true);
          this.loader = false;
        },
      });
  }

  // This method is used to handle the on destroy lifecycle hook
  ngOnDestroy(): void { this.sub?.unsubscribe(); }

  // This method is used to toggle using id and event
  toggle(id: string, event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    checked ? this.selectedIds.add(id) : this.selectedIds.delete(id);
  }
  // This method is used to all checked
  allChecked(): any {
    return this.paginatedDocuments.length &&
      this.paginatedDocuments.every((r: any) => this.selectedIds.has(r.documentId));
  }
  // This method is used to toggle all using event
  toggleAll(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    if (checked) this.paginatedDocuments.forEach((r: any) => this.selectedIds.add(r.documentId));
    else this.paginatedDocuments.forEach((r: any) => this.selectedIds.delete(r.documentId));
  }
  download() {
    if (!this.selectedIds.size) {
      return;
    }
    const selectedDocs = this.allDocuments.filter((doc: any) =>
      this.selectedIds.has(doc.documentId)
    );
    selectedDocs.forEach((doc: any) => this.downloadDocument(doc));
  }

  filterByMembership(option: any) {
    this.accountCSN = "";
    this.accountId = "";
    if (option && option?.selectedLov?.isCSN) {
      this.accountCSN = option.selectedLov?.Value
        ? option.selectedLov.Value
        : this.sharedService.getCsnAccountId('csn');
      this.selectedMembershipName = option.selectedLov['Name'];
    } else {
      this.accountId = option?.selectedLov?.Value
        ? option.selectedLov.Value
        : this.sharedService.getCsnAccountId('id');
      this.selectedMembershipName = option.selectedLov['Name'];
    }
    if (!option?.selectedLov && option != null) {
      this.accountCSN = this.accountCSN || option;
      if (!this.accountCSN) {
        this.accountId = option;
      }
    }
    this.getMemberDocuments();
  }

  search() {
    this.applySearchFilter();
  }

  removeSearch(e: any) {
    const value = (e?.target?.value ?? '').trim();
    if (!value) {
      this.listOfDocuments = [...this.allDocuments];
      this.updatePagination(true);
    }
  }

  // This method is used to downlaod single/multiple documents
  downloadDocument(doc: any) {
    const documentId = doc?.documentId;
    const folderId = doc?.memberFolderId || doc?.folderId;
    const memNumber = this.accountCSN || this.accountId || this.filterForm.get("membership")?.value;
    if (!documentId || !folderId) {
      return;
    }
    this.downloadingIds.add(documentId);
    this.sharedService
      .getEncryption(DocumentServiceType.MEMBERSHIP_WALLET, { memNumber })
      .subscribe({
        next: (encryptionResponse: any) => {
          if (!encryptionResponse) {
            this.downloadingIds.delete(documentId);
            return;
          }
          const response: any = Utils.decodeAndStringify(encryptionResponse);
          const validation = environment.documentEncryption
            ? response.validation
            : Utils.getDubaiDateTime();

          this.attachmentService
            .downloadFile(documentId, folderId, validation)
            .pipe(finalize(() => this.downloadingIds.delete(documentId)))
            .subscribe({
              next: (blob) => {
                const url = window.URL.createObjectURL(blob);
                const a = window.document.createElement('a');
                a.href = url;
                const fileName = doc?.name || doc?.label || doc?.documentType || 'document';
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);
              },
              error: () => {
                this.downloadingIds.delete(documentId);
              },
            });
        },
        error: () => {
          this.downloadingIds.delete(documentId);
        },
      });
  }

  // This method is used to search document
  private applySearchFilter() {
    const query = (this.filterForm.get('search')?.value || '').toString().trim().toLowerCase();
    if (!query) {
      this.listOfDocuments = [...this.allDocuments];
      this.updatePagination(true);
      return;
    }
    this.listOfDocuments = this.allDocuments.filter((doc: any) => {
      const label = (doc?.label || '').toString().toLowerCase();
      const documentType = (doc?.documentType || '').toString().toLowerCase();
      const notes = (doc?.notes || '').toString().toLowerCase();
      return label.includes(query) || documentType.includes(query) || notes.includes(query);
    });
    this.updatePagination(true);
  }

  get totalPages(): number {
    return Math.ceil(this.totalRecords / this.pageSize);
  }

  get paginatedDocuments(): any[] {
    const start = (this.currentPage - 1) * this.pageSize;
    return this.listOfDocuments.slice(start, start + this.pageSize);
  }

  goToPage(page: number): void {
    if (page < 1 || page > this.totalPages) {
      return;
    }
    this.currentPage = page;
  }

  prevPage(): void {
    this.goToPage(this.currentPage - 1);
  }

  nextPage(): void {
    this.goToPage(this.currentPage + 1);
  }

  private updatePagination(resetPage: boolean = false): void {
    this.totalRecords = this.listOfDocuments.length;
    if (resetPage || this.currentPage > this.totalPages) {
      this.currentPage = 1;
    }
  }
}
